<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/trip-checkout" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Share Payment</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="amount-display">
    <div class="success-icon-container">
      <ion-icon name="checkmark-circle" color="success"></ion-icon>
    </div>
    <span class="amount-label">Payment Request Created</span>
    <h1>${{ valorTotal | number:'1.2-2' }}</h1>
    <p class="fee-note" *ngIf="feePercent">Includes a {{ feePercent | number:'1.1-2' }}% transaction fee.</p>
    
    <div class="link-container">
      <span class="link-label">Payment Link</span>
      <p class="link-preview">{{ url }}</p>
    </div>
  </div>

  <div class="payment-icons">
    <ion-icon name="card-outline"></ion-icon>
    <ion-icon name="logo-paypal"></ion-icon>
    <ion-icon name="logo-apple"></ion-icon>
    <ion-icon name="logo-google"></ion-icon>
  </div>

  <div class="actions-container">
    <ion-button expand="block" color="primary" fill="solid" (click)="shareLink()">
      <ion-icon name="share-social-outline" slot="start"></ion-icon>
      Share via Apps
    </ion-button>

    <ion-button expand="block" color="secondary" fill="outline" (click)="sendSMS()">
      <ion-icon name="chatbubble-outline" slot="start"></ion-icon>
      Send via Text
    </ion-button>

    <ion-button expand="block" color="medium" fill="clear" (click)="copyLink()">
      <ion-icon name="copy-outline" slot="start"></ion-icon>
      Copy URL to Clipboard
    </ion-button>
  </div>
</ion-content>
